"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVaccinationStatus = createVaccinationStatus;
const utils_1 = require("../../../events/utils");
const vaccinationStatus_1 = require("../../../forms/ltx/phase-i/vaccinationStatus");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    vaccinationStatus: {
        id: "dashboard.vaccination_status",
        defaultMessage: "Védőoltások"
    },
    immunization: {
        id: "dashboard.vaccination_status.immunization",
        defaultMessage: "Immunizáció"
    },
    vaccineName: {
        id: "dashboard.vaccination_status.vaccine_name",
        defaultMessage: "Oltóanyag neve"
    },
    numberOfDoses: {
        id: "dashboard.vaccination_status.number_of_doses",
        defaultMessage: "Oltások száma"
    },
    dateOfLastDose: {
        id: "dashboard.vaccination_status.date_of_last_dose",
        defaultMessage: "Utolsó oltás dátuma"
    }
};
function createVaccinationStatus(intl, options) {
    const tables = createVaccinationStatusTables(intl, options);
    const content = (0, shared_1.createSectionContent)(tables);
    return (0, shared_1.createSection)(intl, {
        label: messages.vaccinationStatus,
        content
    });
}
function createVaccinationStatusTables({ formatMessage, formatMessageMap, formatDate }, { events }) {
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.queries.vaccineType);
    const columns = [
        formatMessage(messages.immunization),
        formatMessage(messages.vaccineName),
        formatMessage(messages.numberOfDoses),
        formatMessage(messages.dateOfLastDose)
    ];
    return relevantEvents
        .filter(event => event.value.length > 0)
        .map(event => {
        const { value: vaccines, timestamp, sid, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const rows = vaccines.map(vaccine => [
            formatMessageMap(vaccinationStatus_1.immunizationMessages, vaccine.immunization),
            vaccine.vaccineName ?? "",
            vaccine.numberOfDoses?.toString() ?? "",
            vaccine.dateOfLastDose ?? ""
        ]);
        return {
            type: "table",
            label: formattedTimestamp,
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            columns,
            rows,
            timestamp,
            sid,
            origin
        };
    })
        .sort(shared_1.compareByTimestamp);
}
